import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SharedService } from 'src/app/core/services/shared.service';
import { CompanyState } from 'src/app/modules/companies/store/company.reducer';
import { InvestmentCompanyState } from 'src/app/modules/investment-companies/store/investment-company.reducer';
import { InvestmentCompaniesStore } from 'src/app/modules/investment-companies/store';
import { CompaniesStore } from 'src/app/modules/companies/store';
import * as CompanyActions from '../../../../modules/companies/store/company.actions';
import { SimpleActionCreator } from '../../../helpers/types';

@Component({
  selector: 'app-detail-view-pep-data',
  templateUrl: './detail-view-pep-data.component.html',
  styles: [
    `
      .company-height {
        height: calc(100vh - 340px);
      }

      .investment-company-height {
        height: calc(100vh - 420px);
      }
    `
  ]
  // ^fixed height to use scroll and all remaining space
})
export class DetailViewPepDataComponent {
  PEPCheckPerformed = false;
  @Input() action: SimpleActionCreator<any>;
  @Input() id: string;
  @Input() state: Observable<CompanyState | InvestmentCompanyState>;
  @Input() stateKey: string;
  @Input() view: string;

  constructor(private sharedService: SharedService, private store: Store<InvestmentCompaniesStore | CompaniesStore>) {}

  refresh(): void {
    this.store.dispatch(this.action({ id: this.id }));
  }

  retrievePEPData(): void {
    this.sharedService.retrievePEPData(this.id, this.view).subscribe((_) => (this.PEPCheckPerformed = true));
  }
}
